import { IconFn, IconSvg } from "../createIcon";

export const CheckboxIcon: IconFn = ({ color = "white", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 14, height: 9 }} {...props}>
    <path d="M2 4.25L5.84615 8L12 2" stroke={color} strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
  </IconSvg>
);
